import i18next from 'i18next';

export const getErrorMessageLiterals = () => [
  {
    message: 'Device already exists',
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_DEVICE_ALREADY_EXISTS_MESSAGE'),
  },
  {
    message: 'Device serial number exists for another device',
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_SERIAL_NUMBER_ALREADY_EXISTS_MESSAGE'),
  },
  {
    message: 'Config for external provider not found for Gomez Group Metering',
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_GG_CONFIG_NOT_FOUND_MESSAGE'),
  },
  {
    message: 'You do not have permission to link this device',
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_FORBIDDEN_LINKING_MESSAGE'),
  },
  {
    message: 'Channel not found in payload',
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_CHANNEL_NOT_FOUND_MESSAGE'),
  },
  {
    message: "Property 'building_id' has invalid value",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_BUILDING_ID_INVALID_VALUE_MESSAGE'),
  },
  {
    message: "Property 'secret_key' has invalid value",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_SECRET_KEY_INVALID_VALUE_MESSAGE'),
  },
  {
    message: "Config parameter 'communication_platform_ip' has invalid value",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_IP_INVALID_VALUE_MESSAGE'),
  },
  {
    message: "Config parameter 'communication_platform_port' has invalid value",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_PORT_INVALID_VALUE_MESSAGE'),
  },
  {
    message: "Config parameter 'reporting_interval_time' has invalid value",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_INTERVAL_TIME_INVALID_VALUE_MESSAGE'),
  },
  {
    message: "Config parameter 'reporting_interval_number' has invalid value",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_INTERVAL_NUMBER_INVALID_VALUE_MESSAGE'),
  },
  {
    message: "Property 'building_id' is required",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_BUILDING_ID_REQUIRED_MESSAGE'),
  },
  {
    message: "Property 'secret_key' is required",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_SECRET_KEY_REQUIRED_MESSAGE'),
  },
  {
    message: "Config parameter 'communication_platform_ip' is required",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_IP_REQUIRED_MESSAGE'),
  },
  {
    message: "Config parameter 'communication_platform_port' is required",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_PORT_REQUIRED_MESSAGE'),
  },
  {
    message: "Config parameter 'reporting_interval_time' is required",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_INTERVAL_TIME_REQUIRED_MESSAGE'),
  },
  {
    message: "Config parameter 'reporting_interval_number' is required",
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_INTERVAL_NUMBER_REQUIRED_MESSAGE'),
  },
  {
    message: 'Serial number must be a numeric value',
    literal: i18next.t('_CREATE_DEVICE_WITHOUT_GATEWAY_ERROR_SERIAL_NUMBER_TYPE_MESSAGE'),
  },
];
